module.exports = "/images/year-calendar-tooltip.svg?1dff8ce20aa220b61e319acead964de6";